import { Injectable } from '@angular/core';

interface ResidentialCoverageIcon {
  title?: string;
  icon?: string;
  iconUrl?: string;
  uid: string;
}

@Injectable({
  providedIn: 'root'
})
export class ResidentialIconService {
  constructor() {}

  icons: ResidentialCoverageIcon[] = [
    {
      title: 'Contents',
      icon: 'house',
      uid: '1003'
    },
    {
      title: 'Loss Of Use',
      icon: 'autorenew',
      uid: '1004'
    },
    {
      title: 'Liability',
      icon: 'security',
      uid: '1005'
    },
    {
      title: 'Med Payment',
      icon: 'medical_services',
      uid: '1006'
    },
    {
      title: 'Workers Compensation',
      icon: 'engineering',
      uid: '1062'
    },
    {
      title: 'Pet Damage',
      icon: 'pets',
      uid: '1007'
    },
    {
      title: 'Water Backup',
      icon: 'water_damage',
      uid: '1008'
    },
    {
      title: 'Replacement Cost',
      icon: 'desktop_access_disabled',
      uid: '1010'
    },
    {
      title: 'Animal Liability Buy Back',
      icon: 'pets',
      uid: '1003'
    },
    {
      title: 'Increased Property Limits   Jewelry, Watches',
      icon: 'savings',
      uid: '1060'
    },
    {
      title: 'Identity Fraud',
      icon: 'badge',
      uid: '1065'
    },
    {
      title: 'Bed Bug',
      icon: 'pest_control',
      uid: '1075'
    },
    {
      title: 'Forced Entry Theft',
      icon: 'pan_tool',
      uid: '1003'
    },
    {
      title: 'Tenants Additional Protection',
      icon: 'add_to_queue',
      uid: '1076'
    },
    {
      title: 'Earthquake',
      icon: 'moving',
      uid: '1061'
    },
    {
      title: 'Theft',
      icon: 'pan_tool',
      uid: '2'
    },
    {
      title: 'Wind / Hail',
      icon: 'umbrella',
      uid: '5'
    },
    {
      title: 'All Other Peril',
      icon: 'security',
      uid: '1'
    },
    {
      title: 'Refrigerated Property',
      iconUrl: './assets/icons/fridge.svg',
      uid: '1072'
    },
    {
      title: 'Self Storage Buy Back',
      icon: 'local_shipping',
      uid: '1081'
    },
    {
      title: 'Limited Rental To Others',
      icon: 'group',
      uid: '1082'
    },
    {
      title: 'Tenants Additional Protection (available in most states)',
      icon: 'paid',
      uid: '1077'
    },
    {
      title: 'Hurricane',
      icon: 'filter_drama',
      uid: '3'
    },
    {
      title: 'Medical',
      icon: 'medical_services',
      uid: 'medical'
    },
    {
      title: 'Liability',
      icon: 'security',
      uid: 'liability'
    },
    {
      title: 'Coverage C',
      icon: 'house',
      uid: 'coverage_c'
    },
    {
      title: 'Equip',
      icon: 'desktop_access_disabled',
      uid: 'equip'
    },
    {
      title: 'Bedbug',
      icon: 'pest_control',
      uid: 'bedbug'
    },
    {
      title: 'Pet Damage',
      icon: 'pets',
      uid: 'pet_damage'
    },
    {
      title: 'Water Backup',
      icon: 'water_damage',
      uid: 'water_backup'
    },
    {
      title: 'All Peril',
      icon: 'security',
      uid: 'all_peril'
    }
  ];

  setIcons(res) {
    if (res && res.coverage_options) {
      res.coverage_options.forEach(option => {
        const found = this.icons.find(icon => icon.uid === option.uid);
        if (found) {
          option.icon = found.icon;
          if (found.iconUrl) {
            option.iconUrl = found.iconUrl;
          }
        } else {
          option.icon = 'adjust';
        }
      });
    }
  }
}
